import { studentApi } from './studentApi';

/**
 * Fetches topic body content (markdown/rich text) for authenticated users.
 * Source: `topic_content` table — same rows admin saves via PUT /api/admin/topics/{id}/content.
 * Graph topic metadata (GET /api/admin/graph/topics/{id}) does not include this field.
 */
export async function getStudentTopicContent(topicId: number): Promise<string | null> {
  try {
    const response = await studentApi.get<{ data?: { content?: string; topicId?: number } }>(
      `/api/topics/${topicId}/content`
    );
    return response.data?.data?.content ?? null;
  } catch (e: unknown) {
    const status = (e as { response?: { status?: number } })?.response?.status;
    if (status === 404) {
      return null;
    }
    console.error('Failed to fetch topic content for student', e);
    return null;
  }
}
